// Chat constants
export const FILTER_ALL = "all";
export const FILTER_CLIENTS = "clients";
export const FILTER_GROUPS = "groups";
export const FILTER_ARCHIVE = "archive";

export const CHAT_MAX_MESSAGE_LENGTH = 4000;
export const CHAT_MAX_FILES_PER_MESSAGE = 8;
export const CHAT_MAX_FILE_SIZE_BYTES = 25 * 1024 * 1024;
export const CHAT_BLOCKED_FILE_EXTENSIONS = new Set([
  "exe",
  "msi",
  "dll",
  "bat",
  "cmd",
  "com",
  "scr",
  "ps1",
  "sh",
  "vbs",
  "js",
  "mjs",
  "cjs",
  "jar",
  "apk",
]);

export const UNSAFE_URL_PROTOCOL_RE = /^(?:javascript|vbscript|file|data:text\/html)/i;
